import { connect } from 'react-redux';
import {
  selectApplePayCountryCode,
  selectApplePayMerchantCapabilities,
  selectApplePaySupportedNetworks,
  selectTopProps,
  selectOnClick,
  selectApplePayBtnColor,
  selectSessionId,
} from '../../../selectors';
import { type StoreState } from '../../../types/StoreState';
import { startApplePayFlow } from '../../../actions/payment/startApplePayFlow';
import { ApplePayController } from './controller';

const connectToProps = connect(
  (state: StoreState) => ({
    countryCode: selectApplePayCountryCode(state),
    merchantCapabilities: selectApplePayMerchantCapabilities(state),
    supportedNetworks: selectApplePaySupportedNetworks(state),
    topProps: selectTopProps(state),
    onClick: selectOnClick(state),
    color: selectApplePayBtnColor(state),
    sessionId: selectSessionId(state),
  }),
  {
    startApplePayFlow,
  },
);

export const ApplePayControllerConnect = connectToProps(ApplePayController);
